/* Personel kayıt ve düzenleme formlarının paylaştığı seçenek listeleri */

export const CITIES = [
  "Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya",
  "Ankara", "Antalya", "Ardahan", "Artvin", "Aydın", "Balıkesir",
  "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl", "Bitlis",
  "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum",
  "Denizli", "Diyarbakır", "Düzce", "Edirne", "Elazığ", "Erzincan",
  "Erzurum", "Eskişehir", "Gaziantep", "Giresun", "Gümüşhane", "Hakkari",
  "Hatay", "Iğdır", "Isparta", "İstanbul", "İzmir", "Kahramanmaraş",
  "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kırıkkale",
  "Kırklareli", "Kırşehir", "Kilis", "Kocaeli", "Konya", "Kütahya",
  "Malatya", "Manisa", "Mardin", "Mersin", "Muğla", "Muş", "Nevşehir",
  "Niğde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Siirt",
  "Sinop", "Sivas", "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat", "Trabzon",
  "Tunceli", "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak"
];

export const CINSIYET = ["Kadın", "Erkek", "Diğer"];
export const MEDENI_HAL = ["Evli", "Bekar"];
export const EGITIM = ["Lisans", "ÖnLisans", "Lise", "OrtaOkul"];
export const EHLIYET = ["A", "B", "C", "D"];

/* TCKN doğrulaması (UserForm ile aynı algoritma) */
export const isValidTCKN = (tckn) => {
  if (tckn.length !== 11) return false;
  if (tckn[0] === "0") return false;
  if (!/^\d+$/.test(tckn)) return false;
  const digits = tckn.split('').map(Number);
  const sumFirst10 = digits.slice(0, 10).reduce((acc, curr, idx) => acc + curr * (idx % 2 === 0 ? 7 : 1), 0);
  if (sumFirst10 % 10 !== digits[9]) return false;
  const sumFirst9 = digits.slice(0, 9).reduce((acc, curr) => acc + curr, 0);
  if (sumFirst9 % 10 !== digits[10]) return false;
  return true;
};

/* ---- Excel içe aktarma şablonu ----
   Başlıklar API'deki EXCEL_PERSONEL_MAP ile birebir aynı olmalıdır. */
export const EXCEL_TEMPLATE_HEADERS = [
  'TCKN', 'Ad Soyad', 'Kullanıcı Adı', 'Şifre', 'Telefon', 'E-posta',
  'Cinsiyet', 'Medeni Hal', 'Eğitim Durumu', 'Ehliyet',
  'Şehir', 'Doğum Yeri', 'Anne Adı', 'Baba Adı',
  'Doğum Tarihi', 'İşe Başlangıç Tarihi', 'Adres',
  'Durum', 'Şirket Kısa Kod', 'Rol',
];

export const EXCEL_SAMPLE_ROWS = [
  {
    'TCKN': '10000000146', 'Ad Soyad': 'Ayşe Yılmaz', 'Kullanıcı Adı': 'ayse.yilmaz',
    'Şifre': 'Gecici123', 'Telefon': '5321112233', 'E-posta': 'ayse.yilmaz@ornek.com',
    'Cinsiyet': 'Kadın', 'Medeni Hal': 'Bekar', 'Eğitim Durumu': 'Lisans', 'Ehliyet': 'B',
    'Şehir': 'İstanbul', 'Doğum Yeri': 'Ankara', 'Anne Adı': 'Fatma Yılmaz', 'Baba Adı': 'Ahmet Yılmaz',
    'Doğum Tarihi': '1992-04-18', 'İşe Başlangıç Tarihi': '2024-01-15',
    'Adres': 'Kadıköy / İstanbul', 'Durum': 1, 'Şirket Kısa Kod': 'IDEKOD', 'Rol': 0,
  },
  {
    'TCKN': '', 'Ad Soyad': 'Mehmet Demir', 'Kullanıcı Adı': 'mehmet.demir',
    'Şifre': 'Gecici456', 'Telefon': '5334445566', 'E-posta': 'mehmet.demir@ornek.com',
    'Cinsiyet': 'Erkek', 'Medeni Hal': 'Evli', 'Eğitim Durumu': 'Lise', 'Ehliyet': '',
    'Şehir': 'Bursa', 'Doğum Yeri': 'Bursa', 'Anne Adı': '', 'Baba Adı': '',
    'Doğum Tarihi': '15.08.1988', 'İşe Başlangıç Tarihi': '2023-11-01',
    'Adres': '', 'Durum': 1, 'Şirket Kısa Kod': 'IDEKOD', 'Rol': 0,
  },
];

export const EXCEL_TEMPLATE_INFO = [
  ['Sütun', 'Zorunlu', 'Açıklama / Kabul edilen değerler'],
  ['TCKN', 'Hayır', '11 haneli T.C. kimlik numarası'],
  ['Ad Soyad', 'EVET', 'Personelin adı ve soyadı'],
  ['Kullanıcı Adı', 'EVET', 'Sisteme giriş için kullanıcı adı (benzersiz olmalı)'],
  ['Şifre', 'Hayır', 'Giriş şifresi'],
  ['Telefon', 'EVET', 'Sadece rakam. Kayıtların anahtarıdır, benzersiz olmalı'],
  ['E-posta', 'Hayır', 'E-posta adresi'],
  ['Cinsiyet', 'Hayır', 'Kadın / Erkek / Diğer'],
  ['Medeni Hal', 'Hayır', 'Evli / Bekar'],
  ['Eğitim Durumu', 'Hayır', 'Lisans / ÖnLisans / Lise / OrtaOkul'],
  ['Ehliyet', 'Hayır', 'A / B / C / D'],
  ['Şehir', 'Hayır', 'İl adı (örn. İstanbul)'],
  ['Doğum Yeri', 'Hayır', 'İl adı (örn. Ankara)'],
  ['Anne Adı', 'Hayır', 'Anne ad soyad'],
  ['Baba Adı', 'Hayır', 'Baba ad soyad'],
  ['Doğum Tarihi', 'Hayır', 'YYYY-AA-GG veya GG.AA.YYYY (hücre tarih biçiminde de olabilir)'],
  ['İşe Başlangıç Tarihi', 'Hayır', 'YYYY-AA-GG veya GG.AA.YYYY'],
  ['Adres', 'Hayır', 'Açık adres'],
  ['Durum', 'Hayır', '0-Pasif / 1-Aktif / 3-Bekleyen'],
  ['Şirket Kısa Kod', 'Hayır', 'Kurum kısa kodu (örn. IDEKOD)'],
  ['Rol', 'Hayır', '0-Kullanıcı / 1-Admin / 2-Ekip Şefi'],
  [],
  ['NOT', '', 'Sütun sırası önemli değildir, başlık adları eşleşmelidir.'],
  ['', '', 'Boş bırakılan hücreler veritabanına boş olarak yazılır.'],
  ['', '', 'Örnek satırları silip kendi verilerinizi girin.'],
];

/* MySQL DATE değerini <input type="date"> formatına çevirir.
   Sunucu dogumt_str/girist_str verdiğinde o kullanılır; bu yalnızca yedek yoldur. */
export const toDateInput = (value) => {
  if (!value) return '';
  const s = String(value);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const d = new Date(s);
  if (isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
